import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const LanguageSelector = () => {
    const { i18n } = useTranslation();
    const { setLanguage } = useLanguage();
    const [isOpen, setIsOpen] = useState(false);

    const languages = [
        { code: 'en', label: 'English' },
        { code: 'de', label: 'Deutsch' },
        { code: 'it', label: 'Italiano' }
    ];

    const currentLang = languages.find(l => l.code === i18n.language) || languages[0];

    const handleLanguageChange = (code) => {
        i18n.changeLanguage(code);
        if (setLanguage) {
            setLanguage(code);
        }
        setIsOpen(false);
    };

    return (
        <div className="relative">
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="flex items-center gap-2 px-3 py-1.5 rounded-lg border border-slate-200 bg-white text-slate-700 hover:bg-slate-50 transition-colors cursor-pointer text-sm font-medium"
            >
                <Globe className="h-4 w-4 text-blue-500" />
                <span className="uppercase">{currentLang.code}</span>
            </button>

            {isOpen && (
                <>
                    <div className="fixed inset-0 z-40" onClick={() => setIsOpen(false)} />
                    <div className="absolute right-0 mt-2 w-32 bg-white border border-slate-200 text-slate-700 rounded-xl shadow-lg z-50 overflow-hidden">
                        {languages.map((lang) => (
                            <button
                                key={lang.code}
                                onClick={() => handleLanguageChange(lang.code)}
                                className={`w-full text-left px-4 py-2 hover:bg-slate-50 transition-colors text-sm ${i18n.language === lang.code ? 'font-bold text-blue-600 bg-blue-50/50' : 'font-medium'
                                    }`}
                            >
                                {lang.label}
                            </button>
                        ))}
                    </div>
                </>
            )}
        </div>
    );
};

export default LanguageSelector;
